import React, { useState, useCallback, memo } from 'react';
import CheckboxTree from 'react-checkbox-tree';
import { findAllParents } from '../../helpers/sharedFunction';
import 'react-checkbox-tree/src/scss/react-checkbox-tree.scss';

const TreeSelector = ({
  tree,
  selected,
  onCheck,
  singleLeafSelection,
  ...props
}) => {
  const [checked, setChecked] = useState(selected || []);
  const [expanded, setExpanded] = useState([]);

  const checkModel = props.checkModel || 'all';

  const handleOnCheck = useCallback(
    (checked) => {
      let values = !checked.length
        ? []
        : checkModel === 'leaf'
        ? checked
        : findAllParents(tree, checked);

      // If singleLeafSelection is enabled and checkModel is 'leaf', limit to one selection
      if (singleLeafSelection && checkModel === 'leaf' && values.length > 1) {
        // Keep only the last item (the one just clicked)
        values = [values[values.length - 1]];
      }

      setChecked(values);
      onCheck(values);
    },
    [onCheck, singleLeafSelection, tree, checkModel],
  );

  return (
    <CheckboxTree
      nodes={tree}
      checkModel={checkModel}
      checked={checked}
      expanded={expanded}
      iconsClass="fa5"
      expandOnClick
      showExpandAll
      onCheck={handleOnCheck}
      onExpand={(expanded) => setExpanded(expanded)}
      {...props}
    />
  );
};

export default memo(TreeSelector);
